export const projects = [
    {
      title: "Amazon Clone/E-Commerce Site",
      description: "React, React-Context-API, Firebase",
      hyperlink: "https://meganriley.github.io/e-shop/",
      image: "/assets/projects/shopping-cart.png",

    },
    {
      title: "Reddit Clone",
      description: "React, Chakra UI, Firebase",
      hyperlink: "https://main--golden-brigadeiros-0a300d.netlify.app/",
      image: "/assets/projects/mobile.png",
    },
  ];